import React from 'react';
import { BUILD_INFO } from '../../utils/buildInfo';
import { EVENT_YEAR } from '../../utils/eventConfig';

const PAINT_GRADIENT = 'linear-gradient(to right, #B8185E, #1B5EA8, #E8B428, #C8392B, #2D7A50)';

const Footer = () => {
  return (
    <footer className="bg-primary text-white mt-auto">
      <div style={{ background: PAINT_GRADIENT, height: '4px' }} />
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-2 md:mb-0 text-white/80">
            &copy; {new Date().getFullYear()} Letavy {EVENT_YEAR}
          </div>
          <div className="text-sm flex flex-col items-end">
            <a
              href="https://letavy.sk"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white text-white/80 hover:underline transition-colors"
            >
              Oficiálna stránka Letavy
            </a>
            <span className="text-xs text-white/50 mt-1">
              Verzia {BUILD_INFO.version} ({BUILD_INFO.buildDate} {BUILD_INFO.buildTime})
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
